<template>
  <v-footer :class="[overrideColor]">
    <div class="footer-font">© 2017- {{ new Date().getFullYear() }} Global Psytech Sdn. Bhd.</div>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      overrideColor: ''
    }
  },
  created: function () {
    if (this.$cookies.get('standard_dashboard_override_color') && this.$cookies.get('standard_dashboard_override_color').trim() !== '') {
      this.overrideColor = this.$cookies.get('standard_dashboard_override_color')
    }
  }
}
</script>

<style>
  .footer-font {
    font-weight: 400;
  }

  .bnm .footer-font {
    font-weight: 200;
  }
</style>
